import { useState } from 'react';
import { faqs, trustPoints } from '@/mocks/home';
import Reveal from '@/pages/home/components/Reveal';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function TrustFaq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="border-y border-accent-200 bg-accent-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="使用说明"
            icon="ri-shield-check-line"
            title="先看这几点，再决定从哪一层进入"
            desc="关于分类方式、标签维护和更新节奏，下面把最常被问到的几个问题一次说清楚，省得你在目录里来回试。"
          />
        </Reveal>

        <Reveal>
          <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3">
            {trustPoints.map((point) => (
              <div
                key={point.title}
                className="rounded-lg border border-accent-200 bg-background-50 p-5"
              >
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-background-50">
                  <i className={`${point.icon} text-lg`}></i>
                </span>
                <h3 className="mt-3.5 font-heading text-base font-semibold text-foreground-950">
                  {point.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{point.desc}</p>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal>
          <div className="mt-10 overflow-hidden rounded-lg border border-accent-200 bg-background-50">
            <div className="flex items-center gap-3 border-b border-accent-200 bg-background-100 px-5 py-4">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-question-answer-line text-base"></i>
              </span>
              <h3 className="font-heading text-base font-semibold text-foreground-950">常见问题</h3>
              <span className="ml-auto text-xs text-foreground-500">共 {faqs.length} 条</span>
            </div>

            <div className="divide-y divide-background-200">
              {faqs.map((faq, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={faq.q}>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      className="flex w-full cursor-pointer items-center gap-3 px-5 py-4 text-left transition-colors hover:bg-background-100"
                      aria-expanded={isOpen}
                    >
                      <span
                        className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-medium ${
                          isOpen
                            ? 'bg-primary-500 text-background-50'
                            : 'bg-background-200 text-foreground-700'
                        }`}
                      >
                        {index + 1}
                      </span>
                      <span className="flex-1 text-sm font-medium text-foreground-900 md:text-[15px]">
                        {faq.q}
                      </span>
                      <span className="flex h-5 w-5 shrink-0 items-center justify-center text-foreground-400">
                        <i className={isOpen ? 'ri-subtract-line text-lg' : 'ri-add-line text-lg'}></i>
                      </span>
                    </button>
                    {isOpen && (
                      <div className="px-5 pb-5 pl-14">
                        <p className="text-sm leading-relaxed text-foreground-600">{faq.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}